<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: luoxi
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-12 10:39:19
 -->
<template>
  <ul class="part8">
    <div class="title">
      选择住宿类型（我们需要的房间数量）
      <br />Preferred category of accommodation（We need the following number of
      rooms）
    </div>
    <li>
      <!-- <el-input placeholder="请输入内容" v-model="part8.economicsTwoCh">
        <template slot="prepend">两人间：</template>
      </el-input>-->
      <!-- <el-radio v-model="part8.hotelType" label="0">经济型</el-radio> -->
      <div class="el-input el-input-group el-input-group--prepend radio">
        <el-radio
          v-model="part8.hotelType"
          label="0"
          :disabled="stateCode == 6 || stateCode == 0 ? false : true"
          >经济型</el-radio
        >
      </div>
      <el-input
        placeholder="请输入内容"
        v-model="part8.economicsTwoCh"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">两人间：</template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="part8.economicsAloneCh"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">单人间：</template>
      </el-input>
    </li>
    <li>
      <div class="el-input el-input-group el-input-group--prepend radio">
        <el-radio
          v-model="part8.hotelType"
          label="1"
          :disabled="stateCode == 6 || stateCode == 0 ? false : true"
          >标准型</el-radio
        >
      </div>

      <el-input
        placeholder="请输入内容"
        v-model="part8.standardTwoCh"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">两人间：</template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="part8.standardAloneCh"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">单人间：</template>
      </el-input>
    </li>

    <li>
      <div class="el-input el-input-group el-input-group--prepend radio">
        <el-radio
          v-model="part8.hotelType"
          label="2"
          :disabled="stateCode == 6 || stateCode == 0 ? false : true"
          >高级型</el-radio
        >
      </div>
      <el-input
        placeholder="请输入内容"
        v-model="part8.highTwoCh"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">两人间：</template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="part8.highAloneCh"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">单人间：</template>
      </el-input>
    </li>
    <li>
      <div class="el-input el-input-group el-input-group--prepend radio">
        <el-radio
          v-model="part8.hotelType"
          label="0"
          :disabled="stateCode == 6 || stateCode == 0 ? false : true"
          >Economy Class</el-radio
        >
      </div>
      <el-input
        placeholder="请输入内容"
        v-model="part8.economicsTwoEn"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">multiple person room(s) (3-4 pax)：</template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="part8.economicsAloneEn"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">2-person room(s)：</template>
      </el-input>
    </li>
    <li>
      <div class="el-input el-input-group el-input-group--prepend radio">
        <el-radio
          v-model="part8.hotelType"
          label="1"
          :disabled="stateCode == 6 || stateCode == 0 ? false : true"
          >Standard Class I</el-radio
        >
      </div>
      <el-input
        placeholder="请输入内容"
        v-model="part8.standardTwoEn"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">2-person room(s)：</template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="part8.standardAloneEn"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">single room(s)</template>
      </el-input>
    </li>
    <!-- <li>
      <el-radio v-model="part8.hotelType" label="2">Standard Class II</el-radio>
      <el-input placeholder="请输入内容" v-model="part8.Standard22En">
        <template slot="prepend">2-person room(s)：</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="part8.Standard21En">
        <template slot="prepend">single room(s)</template>
      </el-input>
    </li>-->
    <li>
      <div class="el-input el-input-group el-input-group--prepend radio">
        <el-radio
          v-model="part8.hotelType"
          label="2"
          :disabled="stateCode == 6 || stateCode == 0 ? false : true"
          >First Class</el-radio
        >
      </div>
      <el-input
        placeholder="请输入内容"
        v-model="part8.highTwoEn"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">2-person room(s)：</template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="part8.highAloneEn"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">single room(s)</template>
      </el-input>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    numberroomsh: {
      type: Object,
      default() {
        return {
          type: 0,
          data: null,
        };
      },
    },
    stateCode: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  components: {},
  computed: {},
  data() {
    return {
      part8: {
        hotelType: "0", //(0.经济型 1.标准型 2. 高级型 3,未选择
        economicsTwoCh: "", //经济型两人间
        economicsTwoEn: "",
        economicsAloneCh: "", //经济型单人间
        economicsAloneEn: "",
        standardTwoCh: "", //标准型双人间
        standardTwoEn: "",
        standardAloneCh: "", //标准型单人间
        standardAloneEn: "",
        highTwoCh: "", //高级型 双人间
        highTwoEn: "",
        highAloneCh: "", //高级型 单人间
        highAloneEn: "",
      },
    };
  },

  created() {},
  mounted() {
    this.getdetails();
  },
  methods: {
    getdetails() {
      this.part8.hotelType = this.numberroomsh.hotelType
        ? this.numberroomsh.hotelType.toString()
        : "";
      this.part8.economicsTwoCh = this.numberroomsh.economicsTwoCh;
      this.part8.economicsTwoEn = this.numberroomsh.economicsTwoEn;
      this.part8.economicsAloneCh = this.numberroomsh.economicsAloneCh;
      this.part8.economicsAloneEn = this.numberroomsh.economicsAloneEn;
      this.part8.standardTwoCh = this.numberroomsh.standardTwoCh;
      this.part8.standardTwoEn = this.numberroomsh.standardTwoEn;
      this.part8.standardAloneCh = this.numberroomsh.standardAloneCh;
      this.part8.standardAloneEn = this.numberroomsh.standardAloneEn;
      this.part8.highTwoCh = this.numberroomsh.highTwoCh;
      this.part8.highTwoEn = this.numberroomsh.highTwoEn;
      this.part8.highAloneCh = this.numberroomsh.highAloneCh;
      this.part8.highAloneEn = this.numberroomsh.highAloneEn;
    },
  },
};
</script>

<style scoped="" lang="scss">
.part8 {
  .title {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #3c4353;
    margin: 48px 100px;
  }

  li {
    display: flex;
    padding-left: 100px;
    padding-right: 100px;
    div {
      width: 32%;
    }
    .radio {
      border: 1px solid #dcdfe6;
      height: 38px;
      display: flex;
      align-items: center;
      padding: 0 20px;
      border-radius: 4px;
      /deep/ .el-radio__label {
        color: rgba(36, 85, 139, 1);
      }
    }

    .el-input {
      /deep/ .el-input-group__prepend {
        border-right: 0;
        color: rgba(36, 85, 139, 1);
        background: white;
        padding-right: 0px;
      }
      /deep/.el-input__inner {
        border-left: 0;
        padding: 0 15px 0 0;
        &:focus {
          border-color: #dcdfe6;
          outline: 0;
        }
      }
    }

    .radiobox {
      width: 30%;
      border: 1px solid gainsboro;
      .el-radio {
        margin-left: 30px;
        margin-top: 14px;
      }
    }
    p {
      color: rgba(36, 85, 139, 1);
      line-height: 32px;
    }
  }

  li:nth-of-type(4) {
    margin-top: 20px;
  }
}
</style>
